import { Dashboard_Messages } from "data/endpoints";
import CustomerState from "infrastructure/store/customer/CustomerState";
import IAppState from "infrastructure/store/IAppState";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import MessageModal from "../MessageModal";
import IMessagesService from "../../IMessagesService";
import { MessageStatus } from "features/messages/enums/messageStatus";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import { loadDataFilterConfig } from "features/shared/helpers/modules";
import MessageSimplifiedHeader from "./MessageSimplifiedHeader";
import MessageSimplified from "./MessageSimplified";
import MessageSimplifiedDTO from "features/messages/dto/MessageSimplifiedDTO";

const messagesfilterJson = loadDataFilterConfig("messagesDataFilter");

const MessagesSection = () => {
  // DI
  const messageService = useInjection<IMessagesService>(
    IocTypes.MessagesService
  );

  // STORE
  const customer = useSelector<IAppState, CustomerState>(
    (store) => store.customer
  ).customer;

  const messageSimplifiedUnreadedCount = useSelector<IAppState, number>(
    (store) => store.messages.messages.unreadedCount
  );

  // STATE
  const [showMessageModel, setShowMessageModal] = useState(false);
  const [modalSelectedMessageId, setModalSelectedMessageId] = useState("");

  // HANDLERS
  const detailButtonClickHandler = (messageId: string) => {
    setModalSelectedMessageId(messageId);
    setShowMessageModal(true);
  };

  const menuItemClickHandler = async (
    messageId: string,
    status: MessageStatus
  ) => {
    await messageService.updateMessageStatus(status, messageId);
    messageService.loadAndStoreMessagesSimplified(customer.customerId!);
  };

  // SUB-RENDERS
  const rendedItem = (message: MessageSimplifiedDTO) => { 
    return (
      <MessageSimplified
        message={message}
        onDetailButtonClick={detailButtonClickHandler}
        onMenuItemClick={menuItemClickHandler}
      />
    );
  }

  // RENDER
  return (
    <>
      <DataGrid 
        gridId={DataGridId.messagesGrid}
        url={Dashboard_Messages}
        filterJson={messagesfilterJson}
        externalDependencies={[messageSimplifiedUnreadedCount]}
        renderItem={rendedItem}
        renderHeader={() => <MessageSimplifiedHeader />}
      />
      {modalSelectedMessageId && (
        <MessageModal
          show={showMessageModel}
          setShow={setShowMessageModal}
          selectedMessageId={modalSelectedMessageId}
          customerId={customer.customerId!}
        />
      )}
    </>
  );
};

export default MessagesSection;